import { Link } from "react-router-dom";
import SearchBox from "./SearchBox";
import { siteStats } from "@/mocks/site";

export default function Hero() {
  return (
    <section className="relative w-full overflow-hidden border-b border-background-200 bg-background-100">
      <div className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-primary-100/70" />
      <div className="pointer-events-none absolute -bottom-32 right-10 h-80 w-80 rounded-full bg-accent-100/60" />

      <div className="relative mx-auto grid max-w-[1280px] grid-cols-1 gap-10 px-4 py-14 md:px-6 md:py-20 lg:grid-cols-12 lg:items-center lg:gap-12">
        <div className="hg-rise lg:col-span-7">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1.5 text-xs font-medium text-primary-700">
            <span className="flex h-3.5 w-3.5 items-center justify-center">
              <i className="ri-signal-tower-line text-sm" />
            </span>
            讨论区正在连线中
          </span>

          <h1 className="mt-5 font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-5xl">
            黑瓜吃料，瓜田连线一起聊
          </h1>
          <p className="mt-4 max-w-xl text-base leading-relaxed text-foreground-600 md:text-lg">
            汇聚围观群众的真实观点，实时跟进当下最热的瓜田话题。无论是追剧、看综艺还是刷直播，都能在这里找到一起聊的人——边吃边聊，不落单。
          </p>

          <div className="mt-7">
            <SearchBox />
          </div>

          <div className="mt-5 flex flex-wrap items-center gap-3">
            <Link
              to="/category/film-tv"
              className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-compass-3-line text-base" />
              </span>
              逛逛话题分类
            </Link>
            <Link
              to="/about"
              className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-information-line text-base" />
              </span>
              了解黑瓜吃料
            </Link>
          </div>

          <dl className="mt-9 grid grid-cols-2 gap-x-6 gap-y-5 sm:grid-cols-4">
            {siteStats.map((stat) => (
              <div key={stat.label} className="flex flex-col">
                <dt className="flex items-center gap-1.5 text-xs text-foreground-500">
                  <span className="flex h-4 w-4 items-center justify-center text-accent-600">
                    <i className={`${stat.icon} text-sm`} />
                  </span>
                  {stat.label}
                </dt>
                <dd className="mt-1.5 font-heading text-2xl font-bold text-foreground-950">
                  {stat.value}
                  <span className="ml-0.5 text-sm font-normal text-foreground-500">
                    {stat.suffix}
                  </span>
                </dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="lg:col-span-5">
          <div className="relative h-[300px] w-full overflow-hidden rounded-card border border-background-200 bg-background-50 md:h-[420px]">
            <img
              src="https://readdy.ai/api/search-image?query=playful%20flat%20illustration%20of%20sliced%20watermelons%2C%20chat%20bubbles%20and%20sparkles%20floating%20on%20a%20warm%20cream%20background%2C%20vibrant%20coral%20red%20and%20fresh%20green%20color%20palette%2C%20minimal%20geometric%20shapes%2C%20editorial%20magazine%20cover%20style%2C%20soft%20natural%20lighting%2C%20clean%20balanced%20composition&width=1000&height=1200&seq=hg-hero-main-01&orientation=portrait"
              alt="黑瓜吃料瓜田连线讨论社区插画"
              className="h-full w-full object-cover object-top"
            />
            <div className="absolute bottom-4 left-4 right-4 flex items-center gap-3 rounded-xl border border-background-200 bg-background-50/95 p-3 backdrop-blur">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-chat-quote-fill text-lg" />
              </span>
              <p className="text-xs leading-relaxed text-foreground-700">
                “同一个瓜，几万种看法。讨论区把大家的观点凑在一起，才最完整。”
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}